export const FILTER_DATA = 'filter_data'
export const LOGGED_IN_USER_NAME = 'logged_in_user_name'
export const LOGGED_IN_USER_ID = 'logged_in_user_id'
export const LOGGED_IN_TOKEN = 'access_token'
export const LOGGED_IN_STOCKIST_ID = 'logged_in_stockist_id'
export const DEV_API_PROXY = 'dev_api_proxy'
export const DEV_ECHO_PROXY = 'dev_echo_proxy'
export const DEV_API_PROXY_OPTIONS = 'dev_api_proxy_options'
export const EXPIRES_IN = 'expires_in'
export const ACCESS_TOKEN = 'access_token'
export const REFRESH_TOKEN = 'refresh_token'
export const EXPIRES_ON = 'expires_on'
export const PERMISSIONS = 'permissions'
export const META = 'metadata'
export const LANG = 'lang'
export const ERROR = 'error'
export const NEXT_URL = 'next_url'
export const RETURN_URL = 'return_url'
export const REQUEST_DENIED = 'request_denied'
export const DENIED_ROUTE_NAME = 'denied_route_name'
export const APP_UPDATED_TIMESTAMP = 'app_updated_timestamp'
export const APP_SCOPE = 'scope'
